import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const Notifications = () => (
  <Card sx={{ mb: 2 }}>
    <CardContent>
      <Typography variant="h6">Notifications</Typography>
      <Typography>No new notifications.</Typography>
    </CardContent>
  </Card>
);

export default Notifications;